module.exports = __webpack_public_path__ + "static/media/not-found.da09d4a4.png";